'use strict';

require("moduleFold/notifiche/scripts/index.js");
require("moduleFold/datasource/scripts/index.js");
var BssBasicField = require("moduleFold/formbuilder/scripts/mixins/BssBasicField");


/**
 * Campo di tipo entity su entity esterna
 * 
 * @class  
 * @param {type} formlyConfig
 * @param {type} formlyValidationMessages
 * @param {Valida} Valida
 */
function BSSZoom(formlyConfig, formlyValidationMessages, Valida){
    formlyConfig.setType($.extend(true, {}, new BssBasicField(), {
        name: 'bsszoom', 
        //extends: 'bssselect',
        template: require("./bsszoom.html"),
        controller: ["$scope", "$filter", "$timeout", "$http", "$state", "ErrorManager", "DSFactory", "GridCfgFactory", require("./BssZoomController")],
        defaultOptions: {
            ngModelElAttrs: {
                'cssCategory': 'bsszoom'
            },
        }
    }));
}

module.exports = BSSZoom;